// src/app/slices/plateHeatexSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PlateHeatexState, IPlateHeatex, IPlateHeatexParams } from '../models';

const initialState: PlateHeatexState = {
  plateHeatexes: {},
  plate_heatex_params: null,
};

const plateHeatexSlice = createSlice({
  name: 'plate_heatex',
  initialState,
  reducers: {
    setPlateHeatex: (state, action: PayloadAction<IPlateHeatex>) => {
      state.plateHeatexes[action.payload.id] = {
        ...action.payload,
        params: action.payload.plate_heat_exchanger_params
          ? JSON.parse(action.payload.plate_heat_exchanger_params)
          : '',
      };
    },
    setPlateHeatexParams: (
      state,
      action: PayloadAction<IPlateHeatexParams>
    ) => {
      state.plate_heatex_params = action.payload;
    },
  },
});

export const { setPlateHeatex, setPlateHeatexParams } =
  plateHeatexSlice.actions;

export default plateHeatexSlice.reducer;
